import { Button } from '@scale/scaleui';
import { useCallback } from 'react';
import save from 'save-file';
import { arrayToCSV } from 'react-scale/corp/components/UI/DataUpload/arrayToCSV';

interface DownloadAsCsvButtonProps {
  data?: object[] | null;
  filename: string;
}

export function DownloadAsCsvButton({ data, filename }: DownloadAsCsvButtonProps) {
  const handleDownload = useCallback(() => {
    if (!data) {
      return;
    }
    const csvData = arrayToCSV(data);
    save(csvData, filename);
  }, [data, filename]);
  return (
    <Button variant="secondary" onClick={handleDownload} disabled={!data}>
      Download as CSV
    </Button>
  );
}
